module.exports = __webpack_public_path__ + "img/profile_icon.d2fcfb23.svg";